import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dealArray',
})
export class DealArrayPipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): unknown {
    console.log(value);
    const params = args[0];
    switch (params['action']) {
      case 'getValueBykey':
        return this.getValueBykey(value, params);
        break;
    }
    return null;
  }

  getValueBykey(value: unknown, params: unknown): any {
    let response = '';
    console.log(params, value);
    for (const item of params['data']) {
      if (item[params['key']] == value) {
        response = item[params['returnKey']];
        break;
      }
    }
    return response;
  }
}
